module.exports = "/_next/static/images/europe-7813de4912e564a551bd16fb73b4d21f.svg";